var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconColorless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 91,
    viewBox: "0 0 89 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8689 3.07266C54.6365 1.41725 52.2944 1.07543 50.6373 2.30911L2.42232 38.2041C0.764652 39.4382 0.420199 41.7814 1.65303 43.4374L18.4364 65.9813C18.5719 66.1633 18.7119 66.3401 18.8559 66.5116L21.4814 60.3854L28.8813 57.6104L29.8063 45.5857L34.5317 60.3854L24.2564 64.0853L23.6151 69.8568C27.1037 71.1414 31.1534 70.6926 34.36 68.3053L70.313 41.5392C75.3564 37.7844 76.4043 30.6563 72.6534 25.618L55.8689 3.07266Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7577 74.9479C56.0797 92.7094 87.1123 76.8665 85.6 51.2281C85.503 49.5841 83.8704 49.1802 82.2277 49.36C69.6083 51.9527 52.9164 60.3367 38.3368 71.3149C37.0944 72.1688 36.6395 73.8639 37.7577 74.9479Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconColorless);
export default __webpack_public_path__ + "static/media/logoIconColorless.893f3e6f.svg";
export { ForwardRef as ReactComponent };